import { http } from '../http';

/** Marca de motocicleta elétrica (lista própria — o espelho do SGA só tem automotores). */
export interface BikeMarca {
  id: string;
  nome: string;
  situacao: string;
  totalModelos: number;
}

/** Modelo do catálogo. `valorReferencia` pré-carrega o Valor Protegido na adesão. */
export interface BikeEletrica {
  id: string;
  marcaId: string;
  marca: string;
  modelo: string;
  valorReferencia: number;
  /**
   * Código FIPE FICTÍCIO que o TI cadastrou para o modelo na tela do SGA (at-46).
   * null = a adesão fecha no SAAC, mas a bike não sobe ao SGA até ser preenchido.
   */
  codigoFipeSga: string | null;
  tipoLegal: 'BICICLETA_ELETRICA' | 'CICLOMOTOR';
  anoModelo: number | null;
  potenciaW: number | null;
  bateriaWh: number | null;
  autonomiaKm: number | null;
  velocidadeMaxKmh: number | null;
  observacoes: string | null;
  ativo: boolean;
  /** SEED = veio da carga inicial e o valor ainda não foi revisado por ninguém. */
  origem: 'SEED' | 'MANUAL';
  atualizadoEm: string;
}

export interface BikeEletricaHistorico {
  id: string;
  bikeEletricaId: string;
  snapshotAnterior: {
    marca?: string;
    modelo?: string;
    valorReferencia?: string;
    codigoFipeSga?: string | null;
    tipoLegal?: string;
    anoModelo?: number | null;
    potenciaW?: number | null;
    bateriaWh?: number | null;
    autonomiaKm?: number | null;
    velocidadeMaxKmh?: number | null;
    observacoes?: string | null;
    ativo?: boolean;
    origem?: string;
  };
  editadoPorId: string | null;
  criadoEm: string;
}

export interface SalvarBikeEletrica {
  marcaId?: string;
  modelo?: string;
  valorReferencia?: number;
  /** null limpa o código. */
  codigoFipeSga?: string | null;
  tipoLegal?: 'BICICLETA_ELETRICA' | 'CICLOMOTOR';
  anoModelo?: number;
  potenciaW?: number;
  bateriaWh?: number;
  autonomiaKm?: number;
  velocidadeMaxKmh?: number;
  observacoes?: string;
  ativo?: boolean;
}

export const listarBikeMarcas = async (params?: {
  busca?: string;
  incluirInativas?: boolean;
}): Promise<BikeMarca[]> => {
  const { data } = await http.get('/bike-eletrica/marcas', {
    params: {
      ...(params?.busca ? { busca: params.busca } : {}),
      ...(params?.incluirInativas ? { incluirInativas: 'true' } : {}),
    },
  });
  return data;
};

export const criarBikeMarca = async (nome: string): Promise<BikeMarca> => {
  const { data } = await http.post('/bike-eletrica/marcas', { nome });
  return data;
};

export const atualizarBikeMarca = async (
  id: string,
  dados: { nome?: string; situacao?: string },
): Promise<BikeMarca> => {
  const { data } = await http.patch(`/bike-eletrica/marcas/${id}`, dados);
  return data;
};

export const listarBikesEletricas = async (params?: {
  marcaId?: string;
  busca?: string;
  incluirInativos?: boolean;
}): Promise<BikeEletrica[]> => {
  const { data } = await http.get('/bike-eletrica', {
    params: {
      ...(params?.marcaId ? { marcaId: params.marcaId } : {}),
      ...(params?.busca ? { busca: params.busca } : {}),
      ...(params?.incluirInativos ? { incluirInativos: 'true' } : {}),
    },
  });
  return data;
};

export const buscarBikeEletrica = async (id: string): Promise<BikeEletrica> => {
  const { data } = await http.get(`/bike-eletrica/${id}`);
  return data;
};

export const criarBikeEletrica = async (
  dados: SalvarBikeEletrica & { marcaId: string; modelo: string; valorReferencia: number },
): Promise<BikeEletrica> => {
  const { data } = await http.post('/bike-eletrica', dados);
  return data;
};

export const atualizarBikeEletrica = async (
  id: string,
  dados: SalvarBikeEletrica,
): Promise<BikeEletrica> => {
  const { data } = await http.patch(`/bike-eletrica/${id}`, dados);
  return data;
};

export const historicoBikeEletrica = async (
  id: string,
): Promise<BikeEletricaHistorico[]> => {
  const { data } = await http.get(`/bike-eletrica/${id}/historico`);
  return data;
};
